module.exports = __webpack_public_path__ + "static/media/about-part-4.131c99ac.jpg";